import script from "./BrideProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./BrideProfile.vue?vue&type=script&setup=true&lang=js"

import "./BrideProfile.vue?vue&type=style&index=0&id=d291cb0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d291cb0a"]])

export default __exports__